

import { Component, OnInit } from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormControl
} from "@angular/forms";
import { RoleType } from "src/enum/roletype";
import { MatDialog } from "@angular/material/dialog";
import { UserSessionService } from "src/app/services/usersession.service";
import { HttpClient } from "@angular/common/http";
import { DateTimeAdapter } from "ng-pick-datetime";
import { VehicleService } from "src/app/services/vehicle.service";
import { ShowutilizationreportComponent } from "../showutilizationreport/showutilizationreport.component";
import * as moment from "moment";
import { RegionService } from "src/app/services/region.service";
import { DivisionService } from "src/app/services/division.service";
import { SubDivisionService } from "src/app/services/subdivision.service";
import { AdministrativeMappingService } from 'src/app/services/administrative-mapping.service';


@Component({
  selector: "app-utilizationreport",
  templateUrl: "./utilizationreport.component.html",
  styleUrls: ["./utilizationreport.component.scss"]
})
export class UtilizationreportComponent implements OnInit {
  VehicleTypeList: any[];
  filterListVehicleType: any[];
  monthName: any;
  machineryDetails1: number;
  [x: string]: any;
  form: FormGroup;
  scheduledEndmin: any;
  scheduledEndmax: any;
  maxDate: Date;
  regionList: any[];
  subdivisionList: any[];
  divisionList: any[];
  filterregionList: any[];
  filterdivisionList: any[];
  filtersubdivisionList: any[];
  filterListsubdivisionList: any[];
  public RoleEnumType = RoleType;
  paymentList: any[];
  filterpaymentList: any[];
  roleId: number;
  currentDate: Date;
  yearsList: any;
  filteryearsList: any[];
  monthsList: any;
  filtermonthsList: any[];
  vehicleName: any;
  filtermonthsUtilizationList2021: any[];
  filtermonthsUtilizationList: any[];
  yearsListTabTwo: any[];
  currentYear: any;
  currentMonth: any;
  filterdata: any;
  filterdata1: any;
  filterdataList: any[] = [];
  //financialyearlist :any[];
  curyear: any;
  today: any;
  financialYearList: any[] = [];
  filterFinancialYearList: any[] = [];
  selectedFinYearId: any;
  constructor(
    private formBuilder: FormBuilder,
    public tripDialog: MatDialog,
    private userSessionService: UserSessionService,
    private regionService: RegionService,
    private vehicleService: VehicleService,
    private httpClient: HttpClient,
    private divisionService: DivisionService,
    private subdivisionService: SubDivisionService,
    private administrativeMappingService: AdministrativeMappingService,
    dateTimeAdapter: DateTimeAdapter<any>
  ) {
    dateTimeAdapter.setLocale("en-IN");
    this.regionList = [];
    this.yearsList = [];
    this.filteryearsList = [];
    this.filtermonthsList = [];
    this.monthsList = [];
    this.divisionList = [];
    this.subdivisionList = [];
    this.filterregionList = [];
    this.filterdivisionList = [];
    this.filtersubdivisionList = [];
    this.roleId = this.userSessionService.roleId();
  }

  ngOnInit(): void {
    this.initializeValidators();
    this.currentYear = new Date().getFullYear();
    this.currentMonth = new Date().getMonth().toString();
    var curMonth = parseInt(this.currentMonth);
    if (curMonth != 0 && curMonth > 2) {
      this.currentYear = this.currentYear + 1;
    }
    this.getYearJson();
    //this.getLookupRegion(true);
    this.form.controls['regionId'].setValue('0');
    this.form.controls['divisionId'].setValue('0');
    this.form.controls['subDivisionId'].setValue('0');

  }
  initializeValidators() {

    this.form = this.formBuilder.group({
      year1: ['', Validators.required],
      regionId: ['', Validators.required],
      divisionId: ['', Validators.required],
      subDivisionId: ['', Validators.required],
      month1: ['', Validators.required],
      machineryDetails1: ['', Validators.required],
    });
  }

  clearregionFilter() {
    this.filterregionList = this.regionList;
  }


  //  changeYear1(event: any) {
  //         // this.form.controls['ScheduledStart'].setValue(null);
  //         let value = this.financialyearlist.filter(x => x.key == event.value)
  //         this.maxDate = value[0].endTs;
  //         this.minDate = value[0].startTs
  //         let x=moment(this.maxDate).format('YYYY-MM-DD')
  //         let y= moment(new Date()).format('YYYY-MM-DD')

  //         if(moment(this.maxDate).format('YYYY-MM-DD')>= moment(new Date()).format('YYYY-MM-DD'))
  //             {
  //               this.maxDate=this.Today
  //             }
  //              this.getLookupRegion(true);
  //       }


  // getRefDate(): string {

  //   const selectedId = this.form.value.year1;

  //   const finYear = this.financialyearlist.find(
  //     y => Number(y.key) === Number(selectedId)
  //   );

  //   if (!finYear || Number(finYear.startYear) === 0) {
  //     return moment().format('YYYY-MM-DD');
  //   }

  //   const today = new Date();

  //   const currentFY =
  //     today.getMonth() + 1 >= 4
  //       ? today.getFullYear()
  //       : today.getFullYear() - 1;

  //   // Current FY => today's date
  //   if (Number(finYear.startYear) === currentFY) {
  //     return moment().format('YYYY-MM-DD');
  //   }
  //   //  return moment().format('YYYY-MM-DD');

  //   return `${finYear.startYear}-04-01`;
  // }




  getLookupRegion(refresh: boolean) {
    const refDate = this.form.value.year1 ?? 0 ;
    this.administrativeMappingService.getRegions(refDate, refresh).subscribe((result) => {
      if (result) {
        this.regionList = [];
        this.filterregionList = [];
        this.regionList = result;
        const regionLength = this.regionList.length;
        this.filterregionList = this.regionList.slice();

        if (regionLength == 1) {
          this.form.controls['regionId'].setValue(this.regionList[0].key);
          this.getLookupDivision(this.form.value.regionId);
          // this.regionId = this.form.value.regionid
          // this.getHireCharts();
          // this.getChartData();
        }
      }
    })
  }


  regionChange(event) {
    this.getLookupDivision(this.form.value.regionId);
    // this.regionId = this.form.value.regionid
    // this.divisionId = 0;
    // this.subdivisionId = 0;
    // this.getHireCharts();
    // this.getChartData();
    this.subdivisionList = [];
    this.filtersubdivision = [];
    this.form.controls['divisionId'].setValue('0');
    this.form.controls['subDivisionId'].setValue('0');
     this.form.controls['machineryDetails1'].setValue('');
    this.form.controls['vehicleId1'].setValue('');
    this.machineryDetails1 = 0;
    this.vehicleName = '';
    this.RegnoList = [];
    this.filterRegnoList = [];
  }

  clearregiondivsionFilter() {
    this.filterdivisionList = this.divisionList.slice();
  }

  getLookupDivision(id) {
    const refDate = this.form.value.year1 ?? 0 ;
    this.administrativeMappingService.getDivisions(id, refDate, true).subscribe(result => {
      if (result) {
        this.divisionList = [];
        this.filterdivisionList = [];
        this.divisionList = result;
        const divisionLength = this.divisionList.length;
        this.filterdivisionList = this.divisionList.slice();



        // if (divisionLength != 1) {

        //   if (this.regionId == 1) {

        //     this.getLookupSubDivision(this.form.value.divisionId);
        //     this.divisionId = this.form.value.divisionId

        //   }

        // }

        if (divisionLength === 1) {
          this.form.controls['divisionId'].setValue(this.divisionList[0].key);
          this.getLookupSubDivision(this.form.value.divisionId);
          // this.divisionId = this.form.value.divisionId
          // this.getHireCharts();
          // this.getChartData();
        } else {
        }
      } else {
      }
    })
  }

  divisionChange() {
    this.getLookupSubDivision(this.form.value.divisionId);
    // this.divisionId = this.form.value.divisionId
    // this.subdivisionId = 0;
    // this.getHireCharts();
    // this.getChartData();
    this.form.controls['subDivisionId'].setValue('0');
     this.form.controls['machineryDetails1'].setValue('');
    this.form.controls['vehicleId1'].setValue('');
    this.machineryDetails1 = 0;
    this.vehicleName = '';
    this.RegnoList = [];
    this.filterRegnoList = [];

  }
  clearregionsubdivsionFilter() {
    this.filtersubdivision = this.subdivisionList.slice();
  }

  getLookupSubDivision(id) {
    const refDate = this.form.value.year1 ?? 0 ;
    this.administrativeMappingService.getSubDivisions(id, refDate, true).subscribe(result => {
      if (result) {
        this.subdivisionList = [];
        this.filtersubdivision = [];
        this.subdivisionList = result.filter(x => x.key != this.registeredSubDivisionId);
        this.filtersubdivision = this.subdivisionList.slice();
        const subdivisionLength = this.subdivisionList?.length;
        if (subdivisionLength === 1) {
          this.form.controls['subDivisionId'].setValue(this.subdivisionList[0].key);
        }
      }
    })
  }

  getYearJson() {

    // const d = new Date();
    // let year = d.getFullYear();
    // let get = this.yearsListTabTwo.filter(x => x.key == year)
    // this.form.controls['year1'].setValue(get[0].key);
    this.regionService.getFinYear(true).subscribe(result => {
      if (result) {
        this.financialyearlist = [];
        this.yearsListTabTwo = [];
        this.financialyearlist = result;
        this.financialyearlist.forEach(element => {
          this.yearsListTabTwo.push(element);
        });
        this.financialyearlist = this.financialyearlist;

        var currentYear = new Date().getFullYear();
        var currentMonth = new Date().getMonth();

        var financialYear = "";
        if (currentMonth >= 0 && currentMonth <= 2) {
          financialYear = "FY " + ((currentYear - 1).toString() + '-' + currentYear.toString().slice(-2));
        } else {
          financialYear = "FY " + ((currentYear).toString() + '-' + (currentYear + 1).toString().slice(-2));
        }
        this.curyear = this.financialyearlist.find(i => i.value == financialYear);

        if (this.financialyearlist.length === 1) {
          this.form.controls["year1"].setValue(
            this.financialyearlist[0].key
          );
        }

        this.form.controls["year1"].setValue(this.curyear.key);

        // this.currentYear = this.financialyearlist.filter(x => x.endYear == this.currentYear);
        // this.form.controls["year1"].setValue(this.currentYear[0].key);
        this.getLookupRegion(true);
        this.getMonthsJson();
      }
    });

  }

  getMonthsJson() {
    this.httpClient.get("assets/monthsreport.json").subscribe(data => {
      if (data) {
        this.monthsList = [];
        this.filtermonthsList = [];
        this.filtermonthsUtilizationList = [];
        this.filtermonthsUtilizationList2021 = [];
        const allOption = {
          key: '0',
          value: "All"
        }

        this.monthsList = data;
        this.filtermonthsList.push(allOption)
        this.filtermonthsUtilizationList.push(allOption)

        this.filtermonthsUtilizationList2021.push(allOption)

        this.monthsList.forEach(element => {
          this.filtermonthsList.push(element)
          this.filtermonthsUtilizationList.push(element)

          if (element.key === '01' || element.key === '02' || element.key === '03') {
            this.filtermonthsUtilizationList2021.push(element)
          }
        });

        this.filtermonthsTabTwo = this.filtermonthsUtilizationList

        const monthsLength = this.monthsList.length;
        const month = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
        let currentDate = new Date();
        let getmonth = month[currentDate.getMonth()]
        if (getmonth == "January") {
          getmonth = "December";
        }
        let get = this.filtermonthsList.filter(x => x.value == getmonth)

        this.form.controls['month1'].setValue(get[0].key);
        this.getVehicleType();
      }
    })
  }

  clearmonthFilter() {
    const allOption = {
      key: '0',
      value: "All"
    }
    this.filtermonthsTabTwo = this.monthsList.slice();
    this.filtermonthsTabTwo.unshift(allOption);
    // this.getMonthsJson();
  }
  getVehicleType() {
    this.vehicleService.getVehicleTypeLookup(true).subscribe(res => {
      if (res) {
        this.VehicleTypeList = [];
        this.filterListVehicleType = [];
        this.VehicleTypeList = res;
        this.filterListVehicleType = this.VehicleTypeList.slice();
        this.filterListVehicleTypeTabTwo = []
        this.VehicleTypeList.forEach(vehicleType => {
          if (vehicleType.vehicleGroupType === 1) {
            this.filterListVehicleTypeTabTwo.push(vehicleType)
          }
        })

      }
    });
  }
  clearmechineryFilter() {
    this.filterListVehicleTypeTabTwo = []
    this.VehicleTypeList.forEach(vehicleType => {
      if (vehicleType.vehicleGroupType === 1) {
        this.filterListVehicleTypeTabTwo.push(vehicleType)
      }
    })
  }

  changeClient1(event) {
    if (this.form.value.machineryDetails1 != "--All--") {
      this.VehicleTypeList.forEach(element => {
        if (element.categoryType == this.form.value.machineryDetails1) {
          this.vehicleName = element.vehicleTypeName;
          this.machineryDetails1 = this.form.value.machineryDetails1;
        }
      });
    } else {
      this.form.value.machineryDetails1 = 0;
      this.machineryDetails1 = 0;
    }
  }
  changeMonth1(event) {
    this.monthsList.forEach(element => {
      if (element.key == event.value) {
        this.monthName = element.value;
      }
    });
    this.getVehicleType();
  }
  changeYear1(event: any) {
    this.form.controls['month1'].setValue('');
    this.form.controls['machineryDetails1'].setValue('');
    this.form.controls['regionId'].setValue('');
    this.form.controls['divisionId'].setValue('');
    this.form.controls['subDivisionId'].setValue('');
    if (this.form.controls['year1'].value === 2021) {
      this.filtermonthsTabTwo = this.filtermonthsUtilizationList2021
      this.form.controls['month1'].setValue('0')
    } else {
      this.filtermonthsTabTwo = this.filtermonthsUtilizationList
    }
    this.getLookupRegion(true);
    // this.getMonthsJson();
  }

  setDate() {
    if (this.form.value.ScheduledEnd) {
      this.form.controls["ScheduledEnd"].setValue(null);
    }
    this.scheduledEndmax = moment(new Date())
      .add(0, "days")
      .format("YYYY-MM-DD");
  }
  clear() {
    this.form.controls["month1"].setValue("");
    this.form.controls["machineryDetails1"].setValue("");
    this.form.controls["year1"].setValue("");
    this.form.controls['regionId'].setValue('');
    this.form.controls['divisionId'].setValue('');
    this.form.controls['subDivisionId'].setValue('');
    this.regionList = [];
    this.filterregionList = [];
    this.divisionList = [];
    this.filterdivisionList = [];
    this.subdivisionList = [];
    this.filtersubdivision = [];
    this.monthsList = [];
    this.filtermonthsList = [];
    this.VehicleTypeList = [];
    this.filterListVehicleType = [];
    this.getYearJson();
    // this.getLookupRegion(true);
  }
  showReport() {
    if (this.form.valid) {
      if (this.form.value.year1 == null) {
        this.form.controls["year1"].setValue(0);
      }
      if (this.form.value.month1 == null) {
        this.form.controls["month1"].setValue(0);
      }
      if (this.form.value.machineryDetails1 == null) {
        this.form.controls["machineryDetails1"].setValue(0);
      }

      var selectyear = this.form.controls["year1"].value;
      var selectmonth = parseInt(this.form.controls["month1"].value);
      this.monthName = "";
      if (selectyear > 0 && selectmonth > 0) {
        this.data = this.filtermonthsTabTwo.filter(a => a.key == selectmonth);
        this.monthName = this.data[0].value;
        this.filterdataList = this.yearsListTabTwo.filter(a => a.key == selectyear);
        this.filterdata1 = this.filterdataList[0];
        if (this.filterdata1 != null) {
          if (selectmonth == 1 || selectmonth == 2 || selectmonth == 3) {
            selectyear = this.filterdata1.endYear;
          } else {
            selectyear = this.filterdata1.startYear;
          }
        }
      } else if (selectyear == 0 && selectmonth > 0) {
        selectyear = 0;
        this.data = this.filtermonthsTabTwo.filter(a => a.key == selectmonth);
        this.monthName = this.data[0].value;
      } else if (selectyear > 0 && selectmonth == 0) {
        this.filterdataList = this.financialyearlist.filter(a => a.key == selectyear);
        this.filterdata1 = this.filterdataList[0];
        selectyear = this.filterdata1.startYear;
      }

      const data = {
        categoryTypeId: this.form.value.machineryDetails1,
        regionId: this.form.value.regionId,
        divisionId: this.form.value.divisionId,
        subDivisionId: this.form.value.subDivisionId,
        categoryName: this.vehicleName,
        monthId: selectmonth.toString(),
        month: this.monthName,
        year: selectyear.toString(),
        ReportType: 13
      };
      const dialogRef = this.tripDialog.open(ShowutilizationreportComponent, {
        autoFocus: false,
        disableClose: true,
        width: "100%",
        height: "90%",
        panelClass: "mat-dialog-bookingreport",
        data
      });
      dialogRef.afterClosed().subscribe(() => { });
    } else {
      this.validateFormControl();
    }
  }
  validateFormControl() {
    Object.keys(this.form.controls).forEach(field => {
      const control = this.form.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({
          onlySelf: true
        });
      }
    });
  }
}

